import { useLogoStore } from '../../store/logo.store';
import { useApplicationStore } from '../../store/application.store';
import { useNavigationStore } from '../../store/navigation.store';
import { Check } from 'lucide-react';
import { logger } from '@/features/help/utils/logger';
import React from 'react';

// Purpose: Displays a fixed progress header on mobile showing current form progress
export const MobileProgressHeader = () => {
  const { structure } = useApplicationStore();
  const { activePage, getVisiblePages } = useNavigationStore();
  const { logoUrl } = useLogoStore();

  const visiblePages = getVisiblePages();
  if (!structure?.pages || visiblePages.length === 0) return null;

  return (
    <div
      className="md:hidden fixed top-0 left-0 right-0 z-40 shadow-sm flex flex-col"
      style={{ backgroundColor: structure.theme?.primary || '#1e40af' }}
    >
      {/* Logo Section */}
      <div className="p-3 flex justify-center ">
        {logoUrl ? (
          <img
            src={logoUrl}
            alt="Company Logo"
            className="max-h-10 w-auto object-contain"
            onError={() => {
              logger.error(
                'MobileProgressHeader',
                'Failed to display logo image despite preloading',
                { logoUrl },
                'logo'
              );
            }}
            onLoad={() => {
              logger.debug(
                'MobileProgressHeader',
                'Logo image displayed successfully in header',
                { logoUrl },
                'logo'
              );
            }}
            loading="eager"
            decoding="sync"
          />
        ) : (
          <div className="h-10 flex items-center justify-center text-gray-400">
            {/* Empty placeholder */}
          </div>
        )}
      </div>

      {/* Progress Steps */}
      <div className="px-4 py-2">
        <div
          className="flex flex-row items-center justify-center gap-3 flex-nowrap"
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            flexWrap: 'nowrap',
          }}
        >
          {visiblePages.map((page, index) => {
            const isCompleted = index < activePage;
            const isCurrent = index === activePage;

            return (
              <React.Fragment key={index}>
                {/* Step Circle */}
                <div
                  className={`h-6 w-6 rounded-full flex items-center justify-center transition-colors ${
                    isCompleted || isCurrent ? 'bg-blue-500' : 'bg-gray-400'
                  }`}
                >
                  {isCompleted ? (
                    <Check className="h-3 w-3 text-white stroke-2" />
                  ) : (
                    <span className="text-xs font-semibold text-white">{index + 1}</span>
                  )}
                </div>

                {/* Connector Line */}
                {index < visiblePages.length - 1 && (
                  <div
                    className="h-px w-6 bg-gray-300"
                    style={{
                      backgroundColor: isCompleted || isCurrent ? '#3b82f6' : '#9ca3af',
                    }}
                  />
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
};
